'use client';
import { Image } from '@nextui-org/react';
import { ImgConf } from '@/config/imgConfig';
import { useClientTranslation } from '@/hook/translate';
import clsx from 'clsx';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import Link from 'next/link';
import { mindfulLink } from '@/config/appLink';
import { useParams } from 'next/navigation';

export default function MindScanBox(props: {
  className?: string;
}) {
  const { t } = useClientTranslation();
  const params = useParams();
  return (
    <div className={
      clsx('scan-box flex items-center justify-center flex-col bg-[#F7F8FA] py-10 w-[380px] px-5', props?.className)
    }>
      <div className='logo-wrap'>
        <Image src={ MindfulAudioImg.BookeyLogo } alt='bookey' height={42} width={140} />
      </div>
      <Image src={ `/download-${params.lng}-pc.png` } alt='Download Bookey APP' width={380} height={50} />
      <div className='install-code pt-[30px] flex'>
        <div className='code-png flex flex-col items-center'>
          <Image src={ ImgConf.DownCode } alt='install code' radius='none' width={90} height={90} className='border-1 border-solid border-[#fff]'  />
          <p className=' text-xs pt-1'>{ t('scanDown') }</p>
        </div>
        <div className='platform ml-1'>
          <Link href={ mindfulLink.iosLink } target='_blank'>
            <Image radius='none' src={ MindfulAudioImg.AppStore } alt='App Store' />
          </Link>
          <Link href={ mindfulLink.androidLink } target='_blank'>
            <Image radius='none' src={ MindfulAudioImg.GooglePlayBadge } alt='Google Play Badge' className='pt-[10px]' />
          </Link>
        </div>
      </div>
    </div>
  );
}
